const angular = require('angular');

const { viewMoreComponentDefinition } = require('./viewmore.component');

angular.module('oly.common')
    .component('olyViewMore', viewMoreComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/viewmore/index.js